import { combineReducers } from 'redux';

// Reducers for the application
import shared from './shared';
import location from './location';
import user from './user';

const reducers = {
  shared,
  location,
  user,
};

export default combineReducers(reducers);
